<template>
    <!-- Zoom -->
    <div v-show='images[selected] && selected <= images.length && images[selected].media_type == "Images"' class='wrapper'>
        <div id="tools">
            <ul>
                <li>
                    <a class='border' id="osd_zoom_in" href="#" title="Zoom In">
                        <img src="/images/zoom_plus_icon.svg" alt="zoom in" >
                    </a>
                </li>
                <li>
                    <a class='border' id="osd_zoom_out" href="#" title="Zoom Out">
                        <img src="/images/zoom_minus_icon.svg" alt="zoom out">
                    </a>
                </li>
                <li>
                    <a class='border' id="osd_full_screen" href="#" title="Full Screen">
                        <img src="/images/view_fullscreen_icon_dkGrey.svg" alt="full screen">
                    </a>
                </li>
                <li class='border index'>
                    <span>{{selected + 1}}/{{images.length}}</span>
                </li>
            </ul>
        </div>

        <div class='openseadragon' id='openseadragon1'></div>
    </div>
</template>

<script>
    export default {
        props: ['images', 'selected'],
        data: function () {
            return {
                osd: null
            }
        },
        watch: {
            images: 'reload',
            selected: function () {
                if (this.osd) {
                    this.osd.goToPage(this.selected)
                }
            },
        },
        methods: {
            // initialize openSeaDragon if not already
            reload: function () {
                if (this.images.length == 0) {
                    if (this.osd) {
                        this.osd.close()
                    }
                }

                if (this.osd) {
                    this.osd.open(this.images)
                } else {
                    this.osd = OpenSeadragon({
                        id: 'openseadragon1',
                        prefixUrl: '/images/image_nav/',
                        maxZoomLevel: 0,
                        autoResize: true,
                        sequenceMode: true,
                        tileSources: this.images,
                        showSequenceControl: false,
                        showHomeControl: false,
                        zoomInButton: 'osd_zoom_in',
                        zoomOutButton: 'osd_zoom_out',
                        fullPageButton: 'osd_full_screen',
                        toolbar: 'tools'
                    })
                }

                this.osd.goToPage(0)
            }
        }
    }
</script>

<style scoped lang="scss">

    .wrapper, .openseadragon {
        width: 100%;
        height: 100%;
    }

    #tools {
        position: absolute !important;
        z-index: 16; /* the buttons default to behind the canvas */
        right: 5%;
        top: 25%;

        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 991px) {
            right: 0;
        }

        ul {
            list-style: none;
        }

        .border {
            border: 1px solid #ddd;
            border-radius: 4px;
            transition: border 0.2s ease-in-out;
        }

        a {
            background-color: lightgrey;
            padding: 5px;
            margin-bottom: 10px;
        }

        .index {
            background-color: lightgrey;
            text-align: center;
        }
    }
</style>
